/**
 * GullyLabs Column Height Sync
 * Desktop only (≥750px): Makes the left image column height
 * follow the right info column height. When accordions open/close,
 * the image section expands/shrinks to match. Hidden scrolling
 * is applied if images exceed the available height.
 */
(function () {
  'use strict';

  const DESKTOP_BP = 750;
  let rafId = null;

  function syncHeights() {
    if (window.innerWidth < DESKTOP_BP) {
      // On mobile, remove any inline styles so layout stays natural
      const mw = document.querySelector('.product__media-wrapper');
      if (mw) mw.style.removeProperty('max-height');
      return;
    }

    const infoWrapper = document.querySelector('.product__info-wrapper');
    const mediaWrapper = document.querySelector('.product__media-wrapper');

    if (!infoWrapper || !mediaWrapper) return;

    const infoHeight = infoWrapper.offsetHeight;

    if (infoHeight > 0) {
      mediaWrapper.style.maxHeight = infoHeight + 'px';
    }
  }

  function requestSync() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(syncHeights);
  }

  function init() {
    const infoWrapper = document.querySelector('.product__info-wrapper');
    const mediaWrapper = document.querySelector('.product__media-wrapper');

    if (!infoWrapper || !mediaWrapper) return;

    // Initial sync
    syncHeights();

    // ResizeObserver on the info column to catch accordion changes
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(function () {
        requestSync();
      });
      ro.observe(infoWrapper);
    }

    // Listen for <details> toggle events (accordion open/close)
    const accordions = infoWrapper.querySelectorAll('details');
    accordions.forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        requestSync();
      });
    });

    // Also listen for custom Liquid accordions (.gully-acc)
    const gullyAccordions = infoWrapper.querySelectorAll('.gully-acc');
    gullyAccordions.forEach(function (detail) {
      if (detail.tagName === 'DETAILS') {
        detail.addEventListener('toggle', function () {
          requestSync();
        });
      }
    });

    // Recalculate on window resize
    window.addEventListener('resize', function () {
      requestSync();
    });

    // Re-sync when images finish loading (they may change the natural height)
    const images = mediaWrapper.querySelectorAll('img');
    images.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () {
          requestSync();
        });
      }
    });

    // Also re-sync after a brief delay to catch any late layouts
    setTimeout(syncHeights, 500);
    setTimeout(syncHeights, 1500);
  }

  // Initialization moved to window.onload at the bottom of the script

  /* ═══════════════════════════════════════════════════════════
     Smooth Accordion Animations for <details> tags
     ═══════════════════════════════════════════════════════════ */
  class SmoothAccordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.gully-acc__body') || el.querySelector('.accordion__content');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      
      if (!this.summary || !this.content) return;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      
      if (this.animation) this.animation.cancel();
      
      this.animation = this.el.animate({ height: [startHeight, endHeight] }, {
        duration: 350,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      });
      
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        
        if (this.animation) this.animation.cancel();
        
        this.animation = this.el.animate({ height: [startHeight, endHeight] }, {
          duration: 350,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
        });
        
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
      });
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      requestSync(); // Re-sync column height after animation finishes
    }
  }

  function initSmoothAccordions() {
    const accordions = document.querySelectorAll('.gully-acc, .accordion details, .product__accordion details');
    accordions.forEach((acc) => {
      if (!acc.dataset.smoothInit) {
        new SmoothAccordion(acc);
        acc.dataset.smoothInit = 'true';
      }
    });
  }

  // Use window.onload instead of DOMContentLoaded to wait for fonts and CSS to fully render
  if (document.readyState === 'complete') {
    init();
    initSmoothAccordions();
  } else {
    window.addEventListener('load', () => {
      init();
      initSmoothAccordions();
    });
  }

})();
